import axios from 'axios'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'

const unauthorizedCode = [401]

console.log("In base"+appConfig.apiPrefix);
const BaseService = axios.create({
    timeout: 60000,
    baseURL: appConfig.apiPrefix,
})

BaseService.interceptors.request.use(config => {

    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME);
    const persistData = deepParseJson(rawPersistData);
    
    const accessToken = persistData.auth.session.token;
    if (appConfig.apiPrefix === 'https://prod-api-f45812482b387606a614a1e3e120be68.haua.io/api') {
        config.headers = {
            applicationKey: 'd8159b7e1e0835bd725231b704b0d157',
            applicationSecret: '1f43d2d042b28d6f5f2a71ccc5b77c16'
        }
    } else {
        config.headers = {
            applicationKey: '1567267e5551fadc9357c7bf1116817fe',
            applicationSecret: '6bef9e116b1fghjb57abd9513a04c2da'
        }
    }
   


    if (accessToken) {
        config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`
    }
    
    return config
}, error => {
    return Promise.reject(error)
})

BaseService.interceptors.response.use(
    response => response,
    error => {

        const { response } = error

        if (response && unauthorizedCode.includes(response.status)) {
            store.dispatch(onSignOutSuccess())
        }

        return Promise.reject(error)
    }
)

export default BaseService